
import { Component, Vue } from "vue-property-decorator";

interface dataCard {
  id: number | any;
  img?: string;
  uri?: string;
}

@Component({
  components: {}
})
export default class MasSitios extends Vue {
  private cardsSites: Array<dataCard> = [];

  private mounted() {
    this.getSitios();
  }

  private getSitios() {
    this.$axios
      .get("mas-sitios")
      .then((res: any) => {
        this.cardsSites = res.data.map((item: any) => ({
          id: item.id,
          img: item.img ? process.env.VUE_APP_MEDIA_URL + "/" + item.img : "",
          uri: item.url
        }));
      })
      .catch(() => {
        this.cardsSites = [];
      });
  }

  private toLink(item: any, target: any) {
    if (item && item != "") {
      window.open(item, target);
    } else {
      return;
    }
  }
}
